import { Stack } from '@mui/material';
import { t } from 'i18next';
import { ClientData } from '../../../../common/types/client-data';
import { InlineNotification } from '../../../../components';
import styles from './RequestedAttributesNotification.module.css';
import { useMemo } from 'react';
import { Trans } from 'react-i18next';

type RequestedAttributesNotificationProps = {
  clientData: ClientData;
  tacUrl?: string;
  privacyPolicyUrl?: string;
};

export const RequestedAttributesNotification = ({
  clientData,
  tacUrl,
  privacyPolicyUrl,
}: RequestedAttributesNotificationProps) => {
  const showRequestedAttributes = useMemo(() => {
    if (clientData?.oidcScopes?.length > 0) {
      if (clientData.oidcScopes.length === 1 && clientData.oidcScopes.includes('openid')) {
        return false;
      }
      return true;
    }
    return false;
  }, [clientData.oidcScopes]);

  if (!showRequestedAttributes) return null;

  return (
    <InlineNotification appearance="info">
      <Stack direction="column" data-testid="requestedAttributesNotification" sx={{
        gap: '8px'
      }}>
        <span>{t('form.main.scopeListTitle')} </span>
        <ul className={styles.list}>
          {clientData.oidcScopes?.map((scope) => {
            if (scope != 'openid') {
              return (
                <li key={scope}>
                  <strong>
                    {t(`oidcScopes.${scope}.short`, {
                      nsSeparator: false,
                      defaultValue: t(`oidcScopes.${scope}.title`, {
                        nsSeparator: false,
                        ageComparator: clientData.ageComparator
                      }),
                    })}
                  </strong>
                </li>
              );
            }
          })}
        </ul>
        <span>
          <Trans i18nKey="form.general.agreeToprivacyPolicy">
            Jätkates nõustud{' '}
            <a className={styles.link} href={tacUrl} target="_blank" rel="noopener noreferrer">
              kasutustingimuste
            </a>{' '}
            ja{' '}
            <a className={styles.link} href={privacyPolicyUrl} target="_blank" rel="noopener noreferrer">
              privaatsuspoliitikaga
            </a>
          </Trans>
        </span>
      </Stack>
    </InlineNotification>
  );
};
